import QueryTemplate from "./index.vue";
var querytemplate = {
  install: function install(Vue) {
    Vue.component("QueryTemplate", QueryTemplate);
  }
};
export default querytemplate;